import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  sr: {
    nav_projects: "Projekti",
    nav_news: "Novosti",
    nav_admin: "Admin",
    nav_login: "Uloguj se",
    nav_register: "Registruj se",
    nav_logout: "Odjavi se",
    hero_tag: "ČLANSKI PORTAL",
    hero_title: "NAŠA HUB",
    hero_sub: "Zajednica koja povezuje Ex-Yu ljude širom sveta kroz projekte, edukacije i digitalno preduzetništvo.",
    auth_cta_title: "Postani deo zajednice",
    auth_cta_sub: "Registruj se da vidiš prezentacije i materijale.",
    projects_title: "Projekti",
    projects_sub: "Istraži naše projekte. Klikni na projekat da vidiš prezentacije (potrebna prijava).",
    status_active: "aktivan",
    status_pending: "u pripremi",
    read_more: "Otvori projekat",
    news_title: "Novosti",
    news_empty: "Još nema novosti.",
    discord_title: "Pridruži se Discord zajednici",
    discord_sub: "Poveži se sa članovima, postavljaj pitanja i budi u toku.",
    discord_btn: "Pridruži se Discord zajednici",
    discord_guide: "Prvi put na Discordu? Pogledaj uputstvo",
    discord_guide_url: "/discord-uputstvo.html",
    propose_title: "Imaš projekat koji bi podelio našoj zajednici?",
    propose_sub: "Predloži svoj projekat i predstavi ga NAŠA zajednici — najbolje ideje dobijaju podršku i vidljivost.",
    propose_btn: "Predloži projekat",
    locked_title: "Zaključan sadržaj",
    locked_msg: "Registruj se da vidiš prezentacije i materijale.",
    login_first: "Uloguj se",
    register_first: "Registruj se",
    // auth pages
    login_title: "Uloguj se",
    register_title: "Registruj se",
    first_name: "Ime",
    last_name: "Prezime",
    email: "Email",
    password: "Lozinka",
    accept_terms: "Prihvatam uslove korišćenja",
    submit_login: "Uloguj se",
    submit_register: "Kreiraj nalog",
    forgot_password: "Zaboravljena lozinka?",
    no_account: "Nemaš nalog?",
    have_account: "Već imaš nalog?",
    forgot_title: "Resetuj lozinku",
    forgot_sub: "Unesi email i poslaćemo ti link za resetovanje.",
    forgot_submit: "Pošalji link",
    reset_title: "Nova lozinka",
    reset_submit: "Sačuvaj lozinku",
    new_password: "Nova lozinka",
    // detail
    section_description: "Opis",
    section_videos: "Video prezentacije",
    section_pdf: "PDF prezentacija",
    section_tutorials: "Zajednica i podrška",
    external_link: "Poseti sajt",
    download_pdf: "Pročitaj PDF prezentaciju",
    pending_content: "Sve je još u pripremi i testiranju od strane naših stručnjaka.",
    no_content: "Sadržaj će uskoro biti dodat.",
    back: "Nazad",
    // admin
    admin_title: "Admin panel",
    tab_projects: "Projekti",
    tab_news: "Novosti",
    tab_members: "Članovi",
    add_project: "Dodaj projekat",
    add_news: "Dodaj novost",
    save: "Sačuvaj",
    cancel: "Otkaži",
    edit: "Izmeni",
    delete: "Obriši",
    joined: "Pridružio se",
  },
  it: {
    nav_projects: "Progetti",
    nav_news: "Notizie",
    nav_admin: "Admin",
    nav_login: "Accedi",
    nav_register: "Registrati",
    nav_logout: "Esci",
    hero_tag: "PORTALE MEMBRI",
    hero_title: "NAŠA HUB",
    hero_sub: "Una community che unisce le persone Ex-Yu in tutta Europa attraverso progetti, formazione e imprenditoria digitale.",
    auth_cta_title: "Entra nella community",
    auth_cta_sub: "Registrati per vedere presentazioni e materiali.",
    projects_title: "Progetti",
    projects_sub: "Esplora i nostri progetti. Clicca per vedere le presentazioni (accesso richiesto).",
    status_active: "attivo",
    status_pending: "in preparazione",
    read_more: "Apri progetto",
    news_title: "Notizie",
    news_empty: "Ancora nessuna notizia.",
    discord_title: "Unisciti alla community Discord",
    discord_sub: "Connettiti con i membri, fai domande e resta aggiornato.",
    discord_btn: "Unisciti alla community Discord",
    discord_guide: "Prima volta su Discord? Leggi la guida",
    discord_guide_url: "/discord-uputstvo-it.html",
    propose_title: "Hai un progetto da condividere con la nostra community?",
    propose_sub: "Proponi il tuo progetto e presentalo alla community NAŠA — le migliori idee ricevono supporto e visibilità.",
    propose_btn: "Proponi un progetto",
    locked_title: "Contenuto bloccato",
    locked_msg: "Registrati per vedere presentazioni e materiali.",
    login_first: "Accedi",
    register_first: "Registrati",
    login_title: "Accedi",
    register_title: "Registrati",
    first_name: "Nome",
    last_name: "Cognome",
    email: "Email",
    password: "Password",
    accept_terms: "Accetto i termini di servizio",
    submit_login: "Accedi",
    submit_register: "Crea account",
    forgot_password: "Password dimenticata?",
    no_account: "Non hai un account?",
    have_account: "Hai già un account?",
    forgot_title: "Reimposta password",
    forgot_sub: "Inserisci l'email e ti invieremo un link.",
    forgot_submit: "Invia link",
    reset_title: "Nuova password",
    reset_submit: "Salva password",
    new_password: "Nuova password",
    section_description: "Descrizione",
    section_videos: "Presentazioni video",
    section_pdf: "Presentazione PDF",
    section_tutorials: "Community e supporto",
    external_link: "Visita il sito",
    download_pdf: "Leggi la presentazione PDF",
    pending_content: "Tutto è ancora in preparazione e test da parte dei nostri esperti.",
    no_content: "Il contenuto sarà aggiunto presto.",
    back: "Indietro",
    admin_title: "Pannello Admin",
    tab_projects: "Progetti",
    tab_news: "Notizie",
    tab_members: "Membri",
    add_project: "Aggiungi progetto",
    add_news: "Aggiungi notizia",
    save: "Salva",
    cancel: "Annulla",
    edit: "Modifica",
    delete: "Elimina",
    joined: "Iscritto",
  },
  en: {
    nav_projects: "Projects",
    nav_news: "News",
    nav_admin: "Admin",
    nav_login: "Log in",
    nav_register: "Sign up",
    nav_logout: "Log out",
    hero_tag: "MEMBERS PORTAL",
    hero_title: "NAŠA HUB",
    hero_sub: "A community connecting Ex-Yu people across Europe through projects, education and digital entrepreneurship.",
    auth_cta_title: "Join the community",
    auth_cta_sub: "Register to see presentations and materials.",
    projects_title: "Projects",
    projects_sub: "Explore our projects. Click one to see presentations (login required).",
    status_active: "active",
    status_pending: "in preparation",
    read_more: "Open project",
    news_title: "News",
    news_empty: "No news yet.",
    discord_title: "Join the Discord community",
    discord_sub: "Connect with members, ask questions and stay up to date.",
    discord_btn: "Join the Discord community",
    discord_guide: "First time on Discord? Read the guide",
    discord_guide_url: "/discord-uputstvo-en.html",
    propose_title: "Have a project to share with our community?",
    propose_sub: "Propose your project and present it to the NAŠA community — the best ideas get support and visibility.",
    propose_btn: "Propose a project",
    locked_title: "Locked content",
    locked_msg: "Register to see presentations and materials.",
    login_first: "Log in",
    register_first: "Sign up",
    login_title: "Log in",
    register_title: "Sign up",
    first_name: "First name",
    last_name: "Last name",
    email: "Email",
    password: "Password",
    accept_terms: "I accept the terms of service",
    submit_login: "Log in",
    submit_register: "Create account",
    forgot_password: "Forgot password?",
    no_account: "No account?",
    have_account: "Already have an account?",
    forgot_title: "Reset password",
    forgot_sub: "Enter your email and we'll send you a reset link.",
    forgot_submit: "Send link",
    reset_title: "New password",
    reset_submit: "Save password",
    new_password: "New password",
    section_description: "Description",
    section_videos: "Video presentations",
    section_pdf: "PDF presentation",
    section_tutorials: "Community & support",
    external_link: "Visit site",
    download_pdf: "Read the PDF presentation",
    pending_content: "Everything is still being prepared and tested by our experts.",
    no_content: "Content will be added soon.",
    back: "Back",
    admin_title: "Admin panel",
    tab_projects: "Projects",
    tab_news: "News",
    tab_members: "Members",
    add_project: "Add project",
    add_news: "Add news",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    joined: "Joined",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("nh_lang") || "sr");
  const setLang = useCallback((l) => {
    localStorage.setItem("nh_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => (translations[lang] && translations[lang][key]) || translations.sr[key] || key, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export const LANGS = [
  { code: "sr", label: "SR" },
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];
